<template>
  <tr>
    <td class="v-align-middle">
      <span>Demande de visite du bureau 2626</span>
    </td>
    <td class="v-align-middle">
      <span>31/07/2016</span>
    </td>
    <td class="v-align-middle">
      <button class="btn btn-sm btn-complete">Détail</button>
    </td>
  </tr>
</template>

<style lang="scss" scoped>
      tr {
        td {
          height: 45px;
          &:nth-child(3) {
            width: 50px;
          }
        }
      }
</style>

<script type="text/babel">
  export default{}
</script>



// WEBPACK FOOTER //
// client/components/LongTermLocationsList/LocationsAskingItem.vue